import { render } from "./Kaban.vue?vue&type=template&id=042c2cea"
import script from "./Kaban.vue?vue&type=script&lang=js"
export * from "./Kaban.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__